  import { css } from "@emotion/react";
import antCssVars from "./antCssVars";

export const GlobalStyle = css`
  @import url('https://fonts.googleapis.com/css2?family=Assistant:wght@200..800&display=swap')

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  :hover::-webkit-scrollbar {
    background-color: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0);
    border-radius: 4px;
  }

  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
  }

  ::-webkit-scrollbar-track {
    background-color: rgba();
  }

  .nlux-AiChat-root.nlux-theme-custom-nova {
    /** Exceptions box */
    --nlux-Exceptions--BackgroundColor: tomato;
    --nlux-Exceptions--BorderColor: darkred;
    --nlux-Exceptions--TextColor: white;

    /** Welcome message */
    --nlux-WelcomeMessage-Avatar--BorderColor: transparent;
    --nlux-WelcomeMessage-Avatar--BackgroundColor: transparent;

    /** Divider between composer and messages */
    --nlux-ChatRoom-Divider--Color: var(--background-color-tertiery);

    /** Conversation loader */
    --nlux-ChatRoom-Loader--Color: #71717a;

    /** Conversation content color */
    --nlux-ChatRoom--BackgroundColor: #ffffff;
    --nlux-ChatRoom--BorderColor: transparent;
    --nlux-ChatRoom--TextColor: #09090B;

    /** Participant info in chat */
    --nlux-ChatItem-ParticipantName--Color: #09090B;

    /* Human message in chat */
    --nlux-HumanMessage--BackgroundColor: #FFEFE1;
    --nlux-HumanMessage--BorderColor: transparent;
    --nlux-HumanMessage--TextColor: #0A0D2D;

    /** AI message in chat */
    --nlux-AiMessage--BackgroundColor: #F5F5F5;
    --nlux-AiMessage--BorderColor: transparent;
    --nlux-AiMessage--TextColor: #0A0D2D;

    /** Prompt input colors */
    --nlux-PromptInput--BackgroundColor: transparent;
    --nlux-PromptInput--BorderColor: transparent;
    --nlux-PromptInput--TextColor: #747586;

    --nlux-PromptInput-Active--BackgroundColor: transparent;
    --nlux-PromptInput-Active--BorderColor: transparent;
    --nlux-PromptInput-Active--TextColor: #747586;

    --nlux-PromptInput-Disabled--BackgroundColor: transprent;
    --nlux-PromptInput-Disabled--TextColor: #747586;
    --nlux-PromptInput-Disabled--BorderColor: transprent;

    --nlux-PromptInput-Placeholder--TextColor: #747586;
    --nlux-PromptInput-Focus-Outline--Color: transparent;

    /** Submit button colors */
    --nlux-SubmitButton--BackgroundColor: transparent;
    --nlux-SubmitButton--BorderColor: transparent;
    --nlux-SubmitButton--TextColor: var(--primary-color);

    --nlux-SubmitButton-Active--BackgroundColor: transparent;
    --nlux-SubmitButton-Active--BorderColor: transparent;
    --nlux-SubmitButton-Active--TextColor: var(--primary-color);

    --nlux-SubmitButton-Disabled--BackgroundColor: transparent;
    --nlux-SubmitButton-Disabled--BorderColor: transparent;
    --nlux-SubmitButton-Disabled--TextColor: #71717a;

    --nlux-SubmitButton-Focus-Outline--Color: transparent;

    /** Code block */
    --nlux-CodeBlock--BackgroundColor: #ffefd5;
    --nlux-CodeBlock--BorderColor: transparent;
    --nlux-CodeBlock--TextColor: black;
    --nlux-CodeBlock-Hover--BackgroundColor: #efe2cf;

    /** Code block copy button */
    --nlux-CodeBlock-CopyButton--BackgroundColor: #aeaea3;
    --nlux-CodeBlock-CopyButton--BorderColor: #c5c5c3;
    --nlux-CodeBlock-CopyButton--TextColor: #ffffff;

    /** Code block copy button in clicked state */
    --nlux-CodeBlock-CopyButton-Clicked--BackgroundColor: #393930;
    --nlux-CodeBlock-CopyButton-Clicked--BorderColor: #393930;
    --nlux-CodeBlock-CopyButton-Clicked--TextColor: #ffffff;

    /** Inline code in markdown */
    --nlux-InlineCode--BackgroundColor: #fff9d8;
    --nlux-InlineCode--BorderColor: transparent;
    --nlux-InlineCode--TextColor: black;

    /** Conversation starters */
    --nlux-ConversationStarter--BackgroundColor: var(--nlux-AiMessage--BackgroundColor);
    --nlux-ConversationStarter--BorderColor: transparent;
    --nlux-ConversationStarter--TextColor: var(--nlux-AiMessage--TextColor);
  }

  .nlux-AiChat-root.nlux-theme-custom-nova {
    user-select: text;
  }

  .nlux-AiChat-root.nlux-theme-custom-nova {
    --nlux-send-icon: url('data:image/svg+xml,\
        <svg viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">\
            <path\
                fill-rule="evenodd" clip-rule="evenodd"\
                d="M100.662 50.6616C100.662 78.2758 78.2758 100.662 50.6616 100.662C23.0473 100.662 0.66156 78.2758 0.66156 50.6616C0.66156 23.0473 23.0473 0.66156 50.6616 0.66156C78.2758 0.66156 100.662 23.0473 100.662 50.6616ZM50.651 27.9339C49.2859 27.9339 48.0614 28.5356 47.2282 29.4883L29.2694 47.447C27.4943 49.2221 27.4943 52.1001 29.2694 53.8753C31.0446 55.6504 33.9226 55.6504 35.6977 53.8753L46.1055 43.4674V68.8429C46.1055 71.3533 48.1406 73.3884 50.651 73.3884C53.1613 73.3884 55.1964 71.3533 55.1964 68.8429V43.4386L65.6331 53.8753C67.4082 55.6504 70.2862 55.6504 72.0613 53.8753C73.8364 52.1001 73.8364 49.2221 72.0613 47.447L53.8795 29.2652C52.9902 28.3759 51.8241 27.9321 50.6585 27.9339L50.651 27.9339Z"\
                fill="currentColor"\ style="fill:currentColor;fill-opacity:1;"\
            />\
        </svg>\
    ');

    --nlux-copy-icon: url('data:image/svg+xml,\
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">\
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 1.25H10.9436C9.10583 1.24998 7.65019 1.24997 6.51098 1.40314C5.33856 1.56076 4.38961 1.89288 3.64124 2.64124C2.89288 3.38961 2.56076 4.33856 2.40314 5.51098C2.24997 6.65019 2.24998 8.10582 2.25 9.94357V16C2.25 17.8722 3.62205 19.424 5.41551 19.7047C5.55348 20.4687 5.81753 21.1208 6.34835 21.6517C6.95027 22.2536 7.70814 22.5125 8.60825 22.6335C9.47522 22.75 10.5775 22.75 11.9451 22.75H15.0549C16.4225 22.75 17.5248 22.75 18.3918 22.6335C19.2919 22.5125 20.0497 22.2536 20.6517 21.6517C21.2536 21.0497 21.5125 20.2919 21.6335 19.3918C21.75 18.5248 21.75 17.4225 21.75 16.0549V10.9451C21.75 9.57754 21.75 8.47522 21.6335 7.60825C21.5125 6.70814 21.2536 5.95027 20.6517 5.34835C20.1208 4.81753 19.4687 4.55348 18.7047 4.41551C18.424 2.62205 16.8722 1.25 15 1.25ZM17.1293 4.27117C16.8265 3.38623 15.9876 2.75 15 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V16C3.75 16.9876 4.38624 17.8265 5.27117 18.1293C5.24998 17.5194 5.24999 16.8297 5.25 16.0549V10.9451C5.24998 9.57754 5.24996 8.47522 5.36652 7.60825C5.48754 6.70814 5.74643 5.95027 6.34835 5.34835C6.95027 4.74643 7.70814 4.48754 8.60825 4.36652C9.47522 4.24996 10.5775 4.24998 11.9451 4.25H15.0549C15.8297 4.24999 16.5194 4.24998 17.1293 4.27117ZM7.40901 6.40901C7.68577 6.13225 8.07435 5.9518 8.80812 5.85315C9.56347 5.75159 10.5646 5.75 12 5.75H15C16.4354 5.75 17.4365 5.75159 18.1919 5.85315C18.9257 5.9518 19.3142 6.13225 19.591 6.40901C19.8678 6.68577 20.0482 7.07435 20.1469 7.80812C20.2484 8.56347 20.25 9.56458 20.25 11V16C20.25 17.4354 20.2484 18.4365 20.1469 19.1919C20.0482 19.9257 19.8678 20.3142 19.591 20.591C19.3142 20.8678 18.9257 21.0482 18.1919 21.1469C17.4365 21.2484 16.4354 21.25 15 21.25H12C10.5646 21.25 9.56347 21.2484 8.80812 21.1469C8.07435 21.0482 7.68577 20.8678 7.40901 20.591C7.13225 20.3142 6.9518 19.9257 6.85315 19.1919C6.75159 18.4365 6.75 17.4354 6.75 16V11C6.75 9.56458 6.75159 8.56347 6.85315 7.80812C6.9518 7.07435 7.13225 6.68577 7.40901 6.40901Z" fill="currentColor"/>\
        </svg>\
    ');
  }

  .nlux-AiChat-root.nlux-theme-custom-nova {
    /**
     * Theme-specific local variables.
     */

    --nlux-nova--FontFamily: 'Inter', sans-serif;
    --nlux-nova--MonoFontFamily: monospace;

    --nlux-nova--BorderWidth: 0;
    --nlux-nova--LineHeight: 1.4;
    --nlux-nova--FlexGap: 12px;

    /**
     * Definitions and overrides of required theme variables.
     */

    /** Exceptions box */
    --nlux-Exceptions--Padding: 5px;
    --nlux-Exceptions--BorderWidth: var(--nlux-nova--BorderWidth);
    --nlux-Exceptions--BorderRadius: 12px;

    /** Welcome message */
    --nlux-WelcomeMessage-Avatar--Width: 48px;
    --nlux-WelcomeMessage-PersonaName--FontSize: 18px;
    --nlux-WelcomeMessage-PersonaName--FontWeight: 600;
    --nlux-WelcomeMessage-Text--FontSize: 15px;
    --nlux-WelcomeMessage-Text--FontWeight: 400;
    --nlux-WelcomeMessage--Gap: 4px;

    /** Divider between conversation and composer */
    --nlux-ChatRoom-Divider--MarginTop: 10px;
    --nlux-ChatRoom-Divider--MarginBottom: 10px;
    --nlux-ChatRoom-Divider--BorderWidth: 1px;

    /** Chat-room container */
    --nlux-ChatRoom--LineHeight: var(--nlux-nova--LineHeight);
    --nlux-ChatRoom--FontWeight: 400;
    --nlux-ChatRoom--FontFamily: var(--nlux-nova--FontFamily);
    --nlux-ChatRoom--FontSize: 16px;

    --nlux-ChatRoom--Padding: 10px;
    --nlux-ChatRoom--BorderRadius: 18px;
    --nlux-ChatRoom--BorderWidth: var(--nlux-nova--BorderWidth);

    /** Chat-room loader */
    --nlux-ChatRoom-Loader--Width: 25px;

    /** Chat item */
    --nlux-ChatItem--AlignItems: flex-end;

    /** Chat item participant info */
    --nlux-ChatItem-ParticipantInfo--Gap: var(--nlux-nova--FlexGap);
    --nlux-ChatItem-ParticipantName--FontSize: 16px;
    --nlux-ChatItem-ParticipantName--FontWeight: 700;

    /** Chat item avatar */
    --nlux-ChatItem-Avatar--Width: 30px;
    --nlux-ChatItem-Avatar--BorderRadius: 50%;
    --nlux-ChatItem-Avatar--BorderWidth: var(--nlux-nova--BorderWidth);

    /** Chat item message */
    --nlux-ChatItem-Message--Gap: var(--nlux-nova--FlexGap); /** Gap between elements within message */

    /** Chat item message in bubbles display layout */
    --nlux-ChatItem-Message-BubbleLayout--BorderWidth: 0px;
    --nlux-ChatItem-Message-BubbleLayout--BorderRadius: 12px;
    --nlux-ChatItem-Message-BubbleLayout--PaddingTopBottom: 10px;
    --nlux-ChatItem-Message-BubbleLayout--PaddingLeftRight: 15px;

    /** Chat item message in list display layout */
    --nlux-ChatItem-Message-ListLayout--BorderWidth: 0px;
    --nlux-ChatItem-Message-ListLayout--BorderRadius: 12px;
    --nlux-ChatItem-Message-ListLayout--PaddingTopBottom: 5px;
    --nlux-ChatItem-Message-ListLayout--PaddingLeftRight: 10px;
    --nlux-ChatItem-Message-ListLayout--MarginTop: -10px;
    --nlux-ChatItem-Message-ListLayout--MarginBottom: 0px;
    --nlux-ChatItem-Message-ListLayout--MarginLeft: 32px;
    --nlux-ChatItem-Message-ListLayout--MarginRight: 0px;

    /** Chat item message code block */
    --nlux-CodeBlock--FontSize: 14px;
    --nlux-CodeBlock--FontFamily: 'Courier New', monospace;
    --nlux-CodeBlock--Padding: 10px;
    --nlux-CodeBlock--BorderWidth: var(--nlux-nova--BorderWidth);
    --nlux-CodeBlock--BorderRadius: 6px;

    /** Code block copy button */
    --nlux-CodeBlock-CopyButton--Width: 22px;
    --nlux-CodeBlock-CopyButton--Height: 22px;
    --nlux-CodeBlock-CopyButton--Padding: 2px;
    --nlux-CodeBlock-CopyButton--BorderRadius: 4px;
    --nlux-CodeBlock-CopyButton--BorderWidth: var(--nlux-nova--BorderWidth);

    /** Inline code in markdown */
    --nlux-InlineCode--BorderRadius: 6px;
    --nlux-InlineCode--BorderWidth: 2px;
    --nlux-InlineCode--Padding: 0 2px;
    --nlux-InlineCode--FontSize: 18px;

    /** Composer */
    --nlux-Composer--Gap: 5px;

    /** Submit button */
    --nlux-SubmitButton--Width: 65px;
    --nlux-SubmitButton--BorderWidth: var(--nlux-nova--BorderWidth);
    --nlux-SubmitButton--BorderRadius: 12px;
    --nlux-SubmitButton-Focus-Outline--Width: 2px;

    /** Composer input */
    --nlux-PromptInput--FontFamily: var(--nlux-nova--FontFamily);
    --nlux-PromptInput--FontSize: 16px;
    --nlux-PromptInput--BorderWidth: 0;
    --nlux-PromptInput--BorderRadius: 12px;
    --nlux-PromptInput-Focus-Outline--Width: 2px;

    /** Conversation starters */
    --nlux-ConversationStarter--Padding: 0 10px;
    --nlux-ConversationStarter--BorderRadius: 6px;
    --nlux-ConversationStarter--BorderWidth: 0;
    --nlux-ConversationStarter--Gap: var(--nlux-nova--FlexGap);
    --nlux-ConversationStarter--Width: 160px;
    --nlux-ConversationStarter--Height: 101px;
  }

  .nlux-chatbot {
    .nlux-conversationStarters-container {
      .nlux-comp-conversationStarters {
        .nlux-comp-conversationStarter {
          padding: 4px;
          align-items: center;
          border: 1px solid rgba(0, 0, 0, 0.2);
          .nlux-comp-conversationStarter-prompt {
            line-height: 1.8rem;
          }
          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }

  html {
    font-size: 10px;
  }

  body {
    // General body rules
    color: var(--font-color-default);
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 1.4rem;
    font-family: 'Assistant', sans-serif;
    padding: 0;
    margin: 0;

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */

    &::-webkit-scrollbar {
      /* WebKit */
      width: 0;
      height: 0;
    }

    h1, h2, h3, h4, h5, h6 {
      font-family: 'Assistant', sans-serif;
    }

    // p {
    //   font-size: 16px;
    // }

    // theme

    // colors
    --white: #ffffff;
    --primary-color: ${antCssVars["primary-color"]};
    --primary-color-hover: rgba(250, 130, 19, 0.04); // #FA8213
    --primary-color-light: rgba(250, 130, 19, 0.15);
    --layout-sider-background-darker: ${antCssVars[
      "layout-trigger-background"
    ]};
    --background-color-base: ${antCssVars["background-color-base"]};
    
    --background-color-primary: #FFFFFF;
    --background-color-secondary: #EEEEEE;
    --background-color-tertiery: #DEDDDE;

    --background-campaign-avatar: #541CAB;
    --secondary-color: rgba(250, 130, 19, 0.75); // #FA8213
    --campaign-stats-background: #EEEEEE;
    --rightbar-content-background: #ffffff;
    --match-green: #52C41A;
    --match-green-hover-background: rgb(82, 196, 26, 0.13);
    --match-green-light: #9bf4bf73;
    --miss-red: #FF4D4F;
    --miss-red-hover-background: rgba(255, 77, 79, .2);
    --separator-grey: #EEEEEE;
    --filter-primary-color: invert(49%) sepia(64%) saturate(1024%)
      hue-rotate(175deg) brightness(103%) contrast(101%);
    --checkbox-background: #ffffff;
    --checkbox-disabled-background: #f9fafc;
    --step-background: #ffffff;
    --checkbox-checked-background: linear-gradient(
        0deg,
        rgba(33, 174, 255, 0.04),
        rgba(33, 174, 255, 0.04)
      ),
      #ffffff;
    --ant-message-notice-content-background: green;
    --notification-success-background: linear-gradient(
        0deg,
        rgba(39, 202, 105, 0.04),
        rgba(39, 202, 105, 0.04)
      ),
      #ffffff;
    --delete-avatar-btn-background: #ffffff;
    --notification-error-background: #fff2f0;
    --filter-background: #EEEEEE;
    --filter-selected-background: #FA8213;
    --filter-selected-filter: invert(52%) sepia(97%) saturate(7498%)
      hue-rotate(199deg) brightness(92%) contrast(97%);
    --disabled-btn-background: #EFEFEF;
    --chart-light-blue: rgba(250, 130, 19, 0.25);
    --chart-dark-blue: #FA8213;
    --dropdown-menu-dark-active-color: #F5F5F5;
    --dropdown-menu-dark-bg-color: #F5F5F5;
    --enriched-company-border-color: #fdf3di;
    --highlighted-text-color: rgba(0, 0, 0, 0.85);
    //fonts
    --alert-error: #fff2f0;
    --dropdown-menu-dark-theme-span: #0A0D2D !important;
    --font-size-base: 1.6rem;
    --font-color-black: #0A0D2D;
    --font-color-disabled-input: rgba(0, 0, 0, 0.65);
    --font-color-button: #152734;
    --font-color-company-name: #0A0D2D;
    --font-color-campaign-stats: #0A0D2D;
    --font-color-default: #0A0D2D;
    --font-color-error: #ff4d4f;
    --font-color-grey-icon: #909ca4;
    --font-color-upgrade-plan: #909ca4;
    --font-color-white: #ffffff;
    --font-weight-bold: 500;
    --font-weight-semibold: 600;
    --font-weight-bold-strong: 700;
    --label-color: #20313e;
    --no-active-tag: #7b8890;
    --gbpage-section-title-size: 2.5rem;

    //borders
    --action-button-border: 0rem solid #ffffff;
    --alert-error-border: 1px solid #ffccc7;
    --button-border: 0.1rem solid var(--primary-color);
    --button-dashed-border: 0.1rem dashed #bbc3c9;
    --border-filters: 0.1rem solid #efefef;
    --button-text-border: 0.1rem solid #ffffff;
    --campaign-card-border: 0.1rem solid var(--separator-grey);
    --campaign-stats-border-right: 0.1rem solid #d8e1e7;
    --campaign-avatar-border: 0.1rem solid rgba(255, 255, 255, 0.5);
    --card-border: 1px solid #f0f0f0;
    --disabled-button-border: 0.1rem solid #ffffff;
    disabled-button-background: #EFEFEF;
    --dropdown-container-border: 0.1rem solid rgb(223, 223, 228);
    --error-border: 0.1rem solid #ff4d4f;
    --firmographics-cell-border: 0.1rem solid rgba(165, 174, 182, 0.5);
    --match-green-border: 0.1rem solid var(--match-green);
    --miss-red-border: 0.1rem solid var(--miss-red);
    --notification-success-border: 0.1rem solid #27ca69;
    --notification-error-border: 0.1rem solid #ffccc7;
    --novable-logo-border: 0.1rem solid #ffffff;
    --results-border: 0.1rem solid #d0d8de;
    --sidebar-header-border: 0.3rem solid #ffffff;
    --soft-border: 0.1rem solid #e8e8e8;
    --stat-card-border: 1px solid #f0f0f0;

    //borders radius
    --border-radius: ${antCssVars["border-radius-base"]};
    --firmographics-cell-border-radius: 1rem;
    --rightbar-button-border-radius: 4px 4px 0px 0px;
    --rightbar-content-border-radius: 0px 4px 4px 4px;

    // box-shadows
    --card-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.02);
    --campaign-name-input-box-shadow: 0 0 0 2px var(--background-color-secondary);
    --campaign-name-input-box-shadow-active: 0 0 0 2px var(--background-color-secondary);
    --campaign-name-input-box-shadow-error: 0 0 0 2px rgba(255, 77, 79, 0.4);
    --company-detail-footer-shadow: 0px 4px 28px rgba(0, 82, 129, 0.22),
      0px -1px 0px #efefef;
    --dropdown-container-border: 0px 6px 15px rgb(0 0 0 / 20%);
    --gb-list-container-shadow: 1px 0px 0px #dde3e6;
    --left-column-box-shadow: 1px 0px 0px #dde3e6;
    --submit-container-box-shadow: 10px 4px 28px rgba(0, 82, 129, 0.22),
      0px -1px 0px #efefef;
    
    // Golden Basket Company content page
    --gb-content-section-left-margin: 0.15rem;
    --gb-header-bottom-margin: 0.3rem;
    --gb-header-icon-size: 1.6rem;
    --gb-header-icon-margin: 0.3rem;
    --gb-content-titles-font-size: 1.7rem;
    --gb-content-font-size: 1.6rem;
  }

  input,
  textarea {
    font-family: "Assistant", sans-serif;
  }

  .ant-message-notice-content {
    background: var(--ant-message-notice-content-background);
  }

  @keyframes inAnimation {
    0% {
      opacity: 0;
      max-height: 0px;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes outAnimation {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      max-height: 0px;
    }
  }

  /* ----------------------------------------------
 * Generated by Animista on 2023-7-25 13:45:14
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation wobble-hor-bottom
 * ----------------------------------------
 */
  @-webkit-keyframes wobble-hor-bottom {
    0%,
    100% {
      -webkit-transform: translateX(40%) translateY(15%);
      transform: translateX(40%) translateY(15%);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
    15% {
      -webkit-transform: translateX(0px) translateY(15%) rotate(-6deg);
      transform: translateX(0px) translateY(15%) rotate(-6deg);
    }
    30% {
      -webkit-transform: translateX(15px) translateY(15%) rotate(6deg);
      transform: translateX(15px) translateY(15%) rotate(6deg);
    }
    45% {
      -webkit-transform: translateX(0px) translateY(15%) rotate(-3.6deg);
      transform: translateX(0px) translateY(15%) rotate(-3.6deg);
    }
    60% {
      -webkit-transform: translateX(8px) rotate(2.4deg);
      transform: translateX(8px) translateY(15%) rotate(2.4deg);
    }
    75% {
      -webkit-transform: translateX(3px) translateY(15%) rotate(-1.2deg);
      transform: translateX(3px) translateY(15%) rotate(-1.2deg);
    }
  }
  @keyframes wobble-hor-bottom {
    0%,
    100% {
      -webkit-transform: translateX(40%) translateY(15%);
      transform: translateX(40%) translateY(15%);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
    15% {
      -webkit-transform: translateX(0px) translateY(15%) rotate(-6deg);
      transform: translateX(0px) translateY(15%) rotate(-6deg);
    }
    30% {
      -webkit-transform: translateX(15px) translateY(15%) rotate(6deg);
      transform: translateX(15px) translateY(15%) rotate(6deg);
    }
    45% {
      -webkit-transform: translateX(0px) translateY(15%) rotate(-3.6deg);
      transform: translateX(0px) translateY(15%) rotate(-3.6deg);
    }
    60% {
      -webkit-transform: translateX(8px) rotate(2.4deg);
      transform: translateX(8px) translateY(15%) rotate(2.4deg);
    }
    75% {
      -webkit-transform: translateX(3px) translateY(15%) rotate(-1.2deg);
      transform: translateX(3px) translateY(15%) rotate(-1.2deg);
    }
  }

  /* ----------------------------------------------
 * Generated by Animista on 2022-7-14 13:27:50
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation scale-up-center
 * ----------------------------------------
 */
  @-webkit-keyframes scale-up-center {
    0% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @keyframes scale-up-center {
    0% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  .ant-table-pagination-right {
    justify-content: center;
  }
`;
